var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatientListClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "M11 12a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.703-2.985L11 14H5a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5zm11.5 2a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zM8 0a5 5 0 1 1 0 10A5 5 0 0 1 8 0m14.5 8a1 1 0 1 1 0 2H16a1 1 0 1 1 0-2zM8 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m14.5 0a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2z"
})));
export default SvgPatientListClose;